import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import ActiveIngredientService from '../../../services/activeIngredientService';
import { DropdownModel } from "../../../models/dropdownModel";
import { Dropdown } from 'primereact/dropdown';
import { InteractionType } from '../../../common/enums';
import { Editor } from 'primereact/editor';
import { DrugToDrugInteractionModel } from "../../../models/activeIngredient";

interface IProps {
  isVisible: boolean,
  cancelClick: any,
  okClick: any,
  currentDrugInteraction: DrugToDrugInteractionModel
  currentActiveIngredientId: number,
  isActiveIngredientDropdownDisabled: boolean,
  selectedLangId: number
}

interface IState {
  isLoading: boolean;
  error: any;
  currentDrugInteraction: DrugToDrugInteractionModel;
  activeIngredientsDropdown: Array<DropdownModel>;
  interactionSeverityDropdown: Array<DropdownModel>;
}

class DrugInteractionAddEditDialog extends React.Component<IProps, IState> {
  activeIngredientService = new ActiveIngredientService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      error: null,
      currentDrugInteraction: this.props.currentDrugInteraction,
      activeIngredientsDropdown: Array<DropdownModel>(0),
      interactionSeverityDropdown: Array<DropdownModel>(0)
    }
  }

  componentDidMount() {
    this.initData();
  }

  initData() {
    let severitiesArray: Array<{ label: string, value: number }> = Object
      .keys(InteractionType)
      .filter(key => typeof InteractionType[key] === 'number')
      .map(key => ({ label: key, value: InteractionType[key] }));

    this.activeIngredientService.getDropdownInteraction(this.props.currentActiveIngredientId).then(
      (data: Array<DropdownModel>) => {
        const firstItem: Array<DropdownModel> = [{ label: 'Select', value: -1 }];
        const current: DrugToDrugInteractionModel = { ...this.state.currentDrugInteraction };
        current.interactionTypeId = severitiesArray[0].value;
        this.setState({
          activeIngredientsDropdown: firstItem.concat(data),
          interactionSeverityDropdown: severitiesArray,
          currentDrugInteraction: current
        });
      })
      .catch(error => {
        this.setState({
          //error
        });
      });
  }

  //Optimize this shit
  handleOkButton = event => {
    event.preventDefault();
    let ingredientDropdownItem = this.state.activeIngredientsDropdown.find(i => i.value === this.state.currentDrugInteraction.interactionIngredientId);
    if (ingredientDropdownItem) {
      this.state.currentDrugInteraction.interactionIngredientName = ingredientDropdownItem.label;
      this.state.currentDrugInteraction.interactionIngredientId = ingredientDropdownItem.value;
    }

    this.props.okClick(this.state.currentDrugInteraction);
  }

  handleCanselButton = () => {
    this.props.cancelClick();
  }

  handleInteractionChange = (key, value) => {
    const currentDrugInteraction: DrugToDrugInteractionModel = { ...this.state.currentDrugInteraction };
    currentDrugInteraction[key] = value;
    this.setState({ currentDrugInteraction: { ...currentDrugInteraction } });
  };

  getDrugToDrugValueContent = (key) => {
    let content = this.state.currentDrugInteraction.drugToDrugInteractionContent.find(r => r.langId == this.props.selectedLangId)
    if (content && content[key]) {
      return content[key];
    }
    return '';
  }

  handleContentChange = (key, value) => {
    const drugInteraction: DrugToDrugInteractionModel = { ...this.state.currentDrugInteraction };
    let content = drugInteraction.drugToDrugInteractionContent.find(r => r.langId == this.props.selectedLangId);
    if (content) {
      content[key] = value;
    }
    this.setState({ currentDrugInteraction: { ...drugInteraction } });
  }

  render() {
    const { activeIngredientsDropdown, interactionSeverityDropdown, currentDrugInteraction } = this.state;

    return (
      <Dialog header="Drug Interaction" responsive={true} width="70%"
        modal={true}
        visible={this.props.isVisible}
        onHide={this.handleCanselButton}
        footer={
          <div>
            <Button label="Add" disabled={!currentDrugInteraction.interactionIngredientId || currentDrugInteraction.interactionIngredientId == 0}
              icon="pi pi-check" onClick={this.handleOkButton} className="p-button-raised" />
            <Button label="Cancel" icon="pi pi-times" onClick={this.handleCanselButton} className="p-button-secondary p-button-raised" />
          </div>
        }>
        <div style={{ minHeight: '400px', maxHeight: '550px' }}>
          <div className="p-fluid p-grid p-md-12">
            <div className="p-col-12 p-md-6">
              <label>Active Ingredients:</label>
              <Dropdown
                disabled={this.props.isActiveIngredientDropdownDisabled}
                value={currentDrugInteraction && currentDrugInteraction.interactionIngredientId ? currentDrugInteraction.interactionIngredientId : -1}
                options={activeIngredientsDropdown}
                onChange={(e) => this.handleInteractionChange('interactionIngredientId', e.value)}
                style={{ width: '100%' }}
              />
            </div>
            <div className="p-col-12 p-md-6">
              <label>Interaction severity:</label>
              <Dropdown
                value={currentDrugInteraction && currentDrugInteraction.interactionTypeId ? currentDrugInteraction.interactionTypeId : -1}
                options={interactionSeverityDropdown}
                onChange={(e) => this.handleInteractionChange('interactionTypeId', e.value)}
                style={{ width: '100%' }}
              />
            </div>
            <div className="p-col-12 p-md-12">
              <label>Consumer description:</label>
              <Editor
                style={{ width: '100%', height: '120px' }}
                onTextChange={(e) => { this.handleContentChange('consumerDecscription', e.htmlValue) }}
                value={this.getDrugToDrugValueContent('consumerDecscription')}
              />
            </div>
            <div className="p-col-12 p-md-12">
              <label>Professional description:</label>
              <Editor
                style={{ width: '100%', height: '120px' }}
                onTextChange={(e) => { this.handleContentChange('professionalDecscription', e.htmlValue) }}
                value={this.getDrugToDrugValueContent('professionalDecscription')}
              />
            </div>
          </div>
        </div>
      </Dialog >
    )
  }
}

export default DrugInteractionAddEditDialog;